import { AnalyticsBrowser } from '@segment/analytics-next';

let _writeKey = null;

export const getWriteKey = () => _writeKey;

const initSegment = (writeKey, integrations = {}) => {
  if (!writeKey || window.analytics) return;

  _writeKey = writeKey;

  window.analytics = AnalyticsBrowser.load(
    { writeKey },
    {
      integrations: {
        ...integrations,
        'Segment.io': {
          deliveryStrategy: {
            strategy: 'standard',
            config: { keepalive: true },
          },
        },
      },
    }
  );
};

export default initSegment;
